import { render, staticRenderFns } from "./mainHeader.vue?vue&type=template&id=f6d5c918&scoped=true&"
import script from "./mainHeader.vue?vue&type=script&lang=js&"
export * from "./mainHeader.vue?vue&type=script&lang=js&"
import style0 from "./mainHeader.vue?vue&type=style&index=0&id=f6d5c918&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d5c918",
  null
  
)

export default component.exports